

import React, { memo, useState } from 'react';

import cx from 'classnames';
import ReactFiles from 'react-files';
import _flatten from 'lodash.flatten';
import '../styles/_files.scss';

const MIN_FILE_SIZE = 0;
const FILE_SIZE_MULTIPLIER = 10000000000;
const MAX_FILE_SIZE_GB = 10 * FILE_SIZE_MULTIPLIER;
const fileExtensions = {
  image: ['image/*'],
  video: ['video/*'],
  audio: ['audio/*'],
  document: ['.pdf', '.doc', '.docx']
};
const allFileTypes = Object.keys(fileExtensions);















function containsItems(array) {
  return array && array.length > 0;
}

function showIllegalTypeError(illegalType) {
  throw new Error(`"${illegalType}" is not an allowed type for Files, please use one of ${JSON.stringify(allFileTypes)}`);
}

function getExtensionsList(allowedTypes) {
  const types = containsItems(allowedTypes) ? allowedTypes : allFileTypes;
  const allowedTypesArray = types.map((type) => fileExtensions[type]);

  return _flatten(allowedTypesArray);
}

function handleDragDrop(setIsVisible, { visible }) {
  return (e) => {
    e.preventDefault();
    setIsVisible(visible);
  };
}

function Files({
  clickable = true,
  multiple = false,
  maxFileSize = MAX_FILE_SIZE_GB,
  minFileSize = MIN_FILE_SIZE,
  dragStyling = false,
  onFilesChange,
  onFilesError,
  allowedTypes,
  handleRef,
  className,
  children
}) {
  const [isVisible, setIsVisible] = useState(false);
  const illegalType = containsItems(allowedTypes) &&
  allowedTypes.find((type) => !fileExtensions[type]);

  if (illegalType) {
    showIllegalTypeError(illegalType);
  }

  const dragEvents = dragStyling ?
  {
    onDrop: handleDragDrop(setIsVisible, { visible: false }),
    onDragLeave: handleDragDrop(setIsVisible, { visible: false }),
    onDragEnter: handleDragDrop(setIsVisible, { visible: true })
  } :
  {};

  return (
    <div {...dragEvents}>
      <ReactFiles
        className={cx(className, 'drop-files', { 'drop-files--active': isVisible && dragStyling })}
        clickable={clickable}
        multiple={multiple}
        maxFileSize={maxFileSize}
        minFileSize={minFileSize}
        onChange={onFilesChange}
        onError={onFilesError}
        accepts={getExtensionsList(allowedTypes)}
        ref={handleRef}>

        {
        isVisible && dragStyling ?

        <>
                <p>
                  <strong>Drag & Drop</strong>
                </p>
                <p>
                  <small>
                    For ease of use, drop your file(s) into here
                  </small>
                </p>
              </> :

        children}

      </ReactFiles>
    </div>);

}

export default memo(Files);